export default {
  title: 'Featured',
};
